function isFunction(value) {
  return typeof value === "function";
}
const resolveValue = (value) => {
  if (isFunction(value)) return value();
  return value;
};
class Behavior {
  constructor(settings, currentActivation) {
    this.settings = settings;
    this.currentActivation = currentActivation;
  }
  getCurrentActivation() {
    return resolveValue(this.currentActivation);
  }
  getSettings() {
    return resolveValue(this.settings);
  }
  // Returns true if the behavior exists in the activation settings,
  // as long as the production/distribution settings do not force
  // overriding sam level behaviors
  existsInActivationSettings(name) {
    var _a, _b, _c, _d;
    if (this.existsInSettings("overrideActivationBehaviors")) {
      return false;
    }
    return ((_d = (_c = (_b = (_a = this.getCurrentActivation) == null ? void 0 : _a.call(this)) == null ? void 0 : _b.settings) == null ? void 0 : _c.behavior) == null ? void 0 : _d[name]) === true;
  }
  // Returns true if the behavior exists in the passed thing...
  existsInThing(name, thing) {
    var _a, _b;
    return ((_b = (_a = thing == null ? void 0 : thing.settings) == null ? void 0 : _a.behavior) == null ? void 0 : _b[name]) === true;
  }
  // Returns true if the behavior exists in settings...
  existsInSettings(name) {
    var _a, _b;
    return ((_b = (_a = this.getSettings()) == null ? void 0 : _a.behavior) == null ? void 0 : _b[name]) === true;
  }
  // Returns true if the behavior exists in the settings or optionally the passed thing...
  exists(name, thing) {
    return this.existsInThing(name, thing) || this.existsInSettings(name) || this.existsInActivationSettings(name);
  }
  // The opposite of exists, specifically checking that it doesn't exists in the thing or settings...
  doesntExist(name, thing) {
    return !this.existsInThing(name, thing) && !this.existsInSettings(name) && !this.existsInActivationSettings(name);
  }
  // Returns the payload for the behavior if it exists (returning the thing value instead of settings if they both exist)...
  get(name, thing) {
    var _a, _b, _c, _d;
    return ((_b = (_a = thing == null ? void 0 : thing.settings) == null ? void 0 : _a.behavior) == null ? void 0 : _b[name]) || ((_d = (_c = this.getSettings()) == null ? void 0 : _c.behavior) == null ? void 0 : _d[name]);
  }
  has(name, thing) {
    var _a, _b;
    return ((_b = (_a = thing == null ? void 0 : thing.settings) == null ? void 0 : _a.behavior) == null ? void 0 : _b[name]) != null;
  }
}
export {
  Behavior
};
